"use strict";
if (location.pathname === '/') {
    document.addEventListener('DOMContentLoaded', () => {
        function smoothScrollToElement(elementId, offset = 0) {
            const target = document.getElementById(elementId);
            if (!target) {
                console.error(`Element with ID '${elementId}' not found.`);
                return;
            }
            const targetOffsetTop = target.getBoundingClientRect().top + window.pageYOffset;
            const startPosition = window.pageYOffset;
            const distance = targetOffsetTop - startPosition - offset;
            const duration = 1000;
            let startTime = null;
            function step(timestamp) {
                if (!startTime)
                    startTime = timestamp;
                const progress = timestamp - startTime;
                const percentage = Math.min(progress / duration, 1);
                const ease = easeOutCubic(percentage);
                window.scrollTo(0, startPosition + distance * ease);
                if (progress < duration) {
                    requestAnimationFrame(step);
                }
            }
            requestAnimationFrame(step);
        }
        function easeOutCubic(t) {
            return 1 - Math.pow(1 - t, 3);
        }
        function getHeaderHeight() {
            const header = document.getElementById("header");
            const admin_header = document.getElementById("wpadminbar");
            const header_height = header ? header.offsetHeight : 0;
            const admin_height = admin_header ? 32 : 0;
            return header_height + admin_height;
        }
        let anchor = document.querySelector('a[href="#jump-contact"]');
        if (anchor) {
            anchor.addEventListener('click', (event) => {
                event.preventDefault();
                smoothScrollToElement('jump-contact', 89);
            });
        }
    });
}
